'use client'

import { useEffect } from 'react'

import { trackErrorPageView } from '@/lib/track-error'

/**
 * Fires GA4 + dataLayer events from the root catch-all 404 (src/app/not-found.tsx).
 * Split into a client component because that file is an async server component
 * rendering its own <html>.
 */
export function RootNotFoundTracker(): null {
  useEffect(() => {
    trackErrorPageView({
      kind: 'not_found',
      description: '404 (root unmatched URL)',
    })
  }, [])
  return null
}
